module.exports = function (input) {
    input = (`${input}` || '').toLowerCase().trim();
    return input.replace(/[^a-z0-9]+/gi, '-'); // Replace non alpha numeric strings with a hyphen.
};



// WEBPACK FOOTER //
// ./src/olycommon/stringhelpers/hyphenate.js